import script from "./AccordionNameInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionNameInput.vue?vue&type=script&setup=true&lang=js"

import "./AccordionNameInput.vue?vue&type=style&index=0&id=61c73d3a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c73d3a"]])

export default __exports__